export function pick<K extends string, T extends Record<K, unknown>>(
  props: readonly K[],
  object: T
) {
  return Object.fromEntries(props.map(prop => [prop, object[prop]])) as Pick<
    T,
    K
  >;
}
